import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberCheckoutAssigningCoverage defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberCheckoutAssigningCoverageService } from 'services/memberCheckoutAssigningCoverage';
 *
 * // create service instance and send/cancel request
 * const memberCheckoutAssigningCoverageService = new MemberCheckoutAssigningCoverageService();
 * const result = await memberCheckoutAssigningCoverageService.fetchData( '<user-id>' ); // fetch data
 * memberCheckoutAssigningCoverageService.cancel(); // cancel an active request
 */
export class MemberCheckoutAssigningCoverageService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const values = get( response, 'body.component.data.state.values' );
            const options = get( response, 'body.component.data.options' );
            const fields = getVisibleItems( get( response, 'body.component.structure.widgetConfig.fields' ), visibility );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    values,
                    options,
                    fields
                },
            };
            
        } catch( errResponse ) {
            return errResponse;
        }
    }
}
